import { render, staticRenderFns } from "./SupportAccountsTable.vue?vue&type=template&id=09252b97"
import script from "./SupportAccountsTable.vue?vue&type=script&lang=js"
export * from "./SupportAccountsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports